/**
 * Created by Denis Kuzin on 30 september 2021
 */

const ConfirmSpeedUpWindow = CleverappsWindow.extend({
    onWindowLoaded: function (options) {
        this.timeLeft = options.timeLeft;
        this.totalDuration = options.totalDuration;
        this.eventName = options.eventName;
        this.callback = options.callback;
        this.price = options.price !== undefined ? options.price : Unit.CalcSpeedUPPrice(this.timeLeft);
        this.source = options.source;
        this.canCoins = options.canCoins === undefined ? true : options.canCoins;

        this._super({
            title: Messages.get("ConfirmSpeedUpWindow.title"),
            name: "ConfirmSpeedUpWindow",
            content: this.createContent(),
            closeButton: true
        });

        const boostTimeMission = cleverapps.missionManager.findByType(Mission.TYPE_BOOSTTIME);
        cleverapps.focusManager.showControlsWhileFocused(boostTimeMission ? "MenuBarCoinsItem" : "MenuBarGoldItem");
    },

    getPerson: function () {
        return cleverapps.styles.ConfirmSpeedUpWindow.person;
    },

    listBundles: function () {
        return ["confirmspeedup_window"];
    },

    createContent: function () {
        const styles = cleverapps.styles.ConfirmSpeedUpWindow;
        const items = [];

        items.push(this.createTitle());
        items.push(this.createTimer());
        items.push(this.createRubyButton());

        return new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createTitle: function () {
        const styles = cleverapps.styles.ConfirmSpeedUpWindow;

        const text = cleverapps.UI.generateOnlyText(Messages.get("ConfirmSpeedUpWindow.text"), cleverapps.styles.FONTS.SPEEDUP_WINDOW_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setDimensions(styles.textWidth, 0);
        text.fitTo(undefined, styles.textHeight);
        return text;
    },

    createRubyButton: function () {
        const styles = cleverapps.styles.ConfirmSpeedUpWindow.buttons;

        return new UseGoldButton({
            price: this.price,
            onClicked: function () {
                this.close();
                this.callback();
            }.bind(this),
            freeIcon: TextWithIcon.ICONS_BY_NAME.speedup,
            canCoins: this.canCoins,
            source: this.source,
            eventName: this.eventName,
            type: cleverapps.styles.UI.Button.Images.button_blue,
            width: styles.button.width,
            height: styles.button.height
        });
    },
    createTimer: function () {
        const styles = cleverapps.styles.ConfirmSpeedUpWindow.timer;
        const countdown = this.countdown = new cleverapps.CountDown(this.timeLeft, {
            onFinish: () => {
                if (!this.closed) {
                    this.close();
                }
            }
        });
        const timer = new cleverapps.CountDownView(countdown, {
            font: cleverapps.styles.FONTS.SPEEDUP_WINDOW_TIMER_TEXT,
            bar: {
                type: ScaledProgressBar.Types.blue_large_with_frames,
                width: styles.width,
                height: styles.height,
                fullValue: this.totalDuration
            },
            icon: {
                json: bundles.big_timer.jsons.big_timer_json,
                animation: "animation"
            }
        });
        timer.bar.progress.runAction(new cc.RepeatForever(
            new cc.Sequence(
                new cc.TintTo(0.6, 160, 160, 160),
                new cc.DelayTime(0.1),
                new cc.TintTo(0.6, 255, 255, 255),
                new cc.DelayTime(0.1)
            )
        ));
        return timer;
    }
});

ConfirmSpeedUpWindow.TRIGGER_PRICE = 10;

ConfirmSpeedUpWindow.isAvailable = function (price) {
    if (price > ConfirmSpeedUpWindow.TRIGGER_PRICE) {
        const boostTimeMission = cleverapps.missionManager.findByType(Mission.TYPE_BOOSTTIME);
        return !boostTimeMission || !MissionManager.hasProperLocation(boostTimeMission.type);
    }
};

cleverapps.styles.ConfirmSpeedUpWindow = {
    person: "worker",
    margin: 40,
    textWidth: 1100,
    textHeight: 135,

    timer: {
        width: 460,
        height: 90
    },

    buttons: {
        margin: 60,
        coinsMargin: 120,

        reward: {
            scale: 1.4
        },

        button: {
            width: 400,
            height: 136,
            margin: 8
        },

        note: {
            margin: 10
        }
    }
};
